import React from "react";
import { Link } from "react-router-dom";
import "../../css/refunds.scss";
import Header from "../common/Header";
import Footer from "../common/Footer";
import { useTranslation } from "react-i18next";

const hasRichHtml = (s) =>
  typeof s === "string" &&
  /<\/?(strong|b|em|i|ul|ol|li|br|a|sup)\b/i.test(s);

const Refunds = () => {
  const { t } = useTranslation();
  const sections = t("refunds.sections", { returnObjects: true }) || [];

  return (
    <div className="refunds-page">
      <Header />
      <main className="refunds__main">
        <div className="refunds__inner">
          <nav
            className="refunds__breadcrumb"
            aria-label={t("refunds.breadcrumbAria")}
          >
            <Link to="/" className="refunds__breadcrumb-link">
              {t("refunds.breadcrumb")}
            </Link>
          </nav>



          <h1 className="refunds__title">{t("refunds.title")}</h1>
          <p className="refunds__intro">{t("refunds.intro")}</p>

          {Array.isArray(sections) &&
            sections.map((sec, idx) => (
              <section key={`refund-sec-${idx}`} className="refunds-sec">
                <h2 className="refunds-sec__title">{sec.title}</h2>
                {(sec.paragraphs || []).map((p, i) =>
                  hasRichHtml(String(p)) ? (
                    <p
                      key={`p-${i}`}
                      className="refunds__p"
                      dangerouslySetInnerHTML={{ __html: p }}
                    />
                  ) : (
                    <p key={`p-${i}`} className="refunds__p">
                      {p}
                    </p>
                  )
                )}
                {Array.isArray(sec.list) && sec.list.length > 0 && (
                  <ul className="refunds__list">
                    {sec.list.map((li, j) =>
                      hasRichHtml(String(li)) ? (
                        <li
                          key={`li-${j}`}
                          dangerouslySetInnerHTML={{ __html: li }}
                        />
                      ) : (
                        <li key={`li-${j}`}>{li}</li>
                      )
                    )}
                  </ul>
                )}
                {(sec.paragraphsTail || []).map((p, i) =>
                  hasRichHtml(String(p)) ? (
                    <p
                      key={`pt-${i}`}
                      className="refunds__p"
                      dangerouslySetInnerHTML={{ __html: p }}
                    />
                  ) : (
                    <p key={`pt-${i}`} className="refunds__p">
                      {p}
                    </p>
                  )
                )}
                {sec.email ? (
                  <p className="refunds__p">
                    <a className="refunds__email" href={`mailto:${sec.email}`}>
                      {sec.email}
                    </a>
                  </p>
                ) : null}
              </section>
            ))}
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Refunds;
